export function getHomeInlineOfferSubmittedKey(locationId: string): string {
  return `home_inline_offer_submitted:${locationId}`;
}

export function markHomeInlineOfferSubmitted(locationId: string): void {
  try {
    sessionStorage.setItem(getHomeInlineOfferSubmittedKey(locationId), "true");
  } catch {
    // sessionStorage unavailable
  }
}

export function hasHomeInlineOfferSubmitted(locationId: string): boolean {
  try {
    return (
      sessionStorage.getItem(getHomeInlineOfferSubmittedKey(locationId)) ===
      "true"
    );
  } catch {
    return false;
  }
}
